import { Skeleton, Spinner } from '@sendible/design-system';

interface Props {
  useSpinner?: boolean;
  skeletonCount?: number;
}

export const LoadingState = ({ useSpinner, skeletonCount = 6 }: Props) => (
  <>
    {useSpinner ? (
      <Spinner size="xl" />
    ) : (
      Array(skeletonCount)
        .fill(' ')
        .map((_, i) => (
          <Skeleton
            key={`skeleton-${i}`}
            width="9rem"
            height="9rem"
          />
        ))
    )}
  </>
);
